import { subscriptionTiers } from '../constants/subscription-tiers.js'
import moment from 'moment-timezone';

const signupFormInitialState = {
  formData: {
    fullName: "",
    email: "",
    password: "",
    phoneNumber: "",
    companyName: "",
    timezone: moment.tz.guess() || "America/New_York",
    clientCount: "",
    agreedToTerms: false,
    domain: "cldportal.com",
    subdomain: "",
    agencyWhiteLabelSubdomain: "",
    plan: subscriptionTiers.TEAM,
    billingInterval: "monthly",
    workspaceCount: 0,
    discountCode: "",
  },
  activeStep: 0,
};

const signupFormReducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case "SESSION_IN_PROGRESS":
      return {
        ...state,
        formData: payload.formData,
        activeStep: payload.activeStep,
      };
    case "UPDATE_NAME":
      return { ...state, formData: { ...state.formData, fullName: payload } };
    case "UPDATE_EMAIL":
      return { ...state, formData: { ...state.formData, email: payload } };
    case "UPDATE_PASSWORD":
      return { ...state, formData: { ...state.formData, password: payload } };
    case "UPDATE_PHONE_NUMBER":
      return {
        ...state,
        formData: { ...state.formData, phoneNumber: payload },
      };
    case "UPDATE_COMPANY_NAME":
      return {
        ...state,
        formData: { ...state.formData, companyName: payload },
      };
    case "UPDATE_TIMEZONE":
      return { ...state, formData: { ...state.formData, timezone: payload } };
    case "UPDATE_CLIENT_COUNT":
        return { ...state, formData: { ...state.formData, clientCount: payload } };  
    case "UPDATE_AGREED_TO_TERMS":
      return { ...state, formData: { ...state.formData, agreedToTerms: payload } };
    case "UPDATE_ACTIVE_STEP":
      return { ...state, activeStep: payload };
    case "UPDATE_PLAN":
      return { ...state, formData: { ...state.formData, plan: payload } };
    case "UPDATE_DOMAIN":
      return { ...state, formData: { ...state.formData, domain: payload } };
    case "UPDATE_SUBDOMAIN":
      return { ...state, formData: { ...state.formData, subdomain: payload } };
    case "UPDATE_WORKSPACE_COUNT":
      return { ...state, formData: { ...state.formData, workspaceCount: payload } };
    case "UPDATE_BILLING_INTERVAL":
      return { ...state, formData: { ...state.formData, billingInterval: payload } };
    case "UPDATE_DISCOUNT_CODE":
      return { ...state, formData: { ...state.formData, discountCode: payload } };
    case "UPDATE_AGENCY_WHITE_LABEL_SUBDOMAIN":
      return { ...state, formData: { ...state.formData, agencyWhiteLabelSubdomain: payload } };
    default:
      throw new Error(`No case for type ${type} found in contentReducer.`);
  }
};

export { signupFormInitialState, signupFormReducer };
